import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { Snackbar } from '@scramble/ui';
import { authService } from '../../services/authService';

export const useResendEmailOtpCode = (email, options) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      authService.resendEmailOtpCode().then(response => {
        const { status, data } = response;
        if (status === 200) {
          Snackbar({ type: 'success', text: data.message });
          queryClient.setQueryData(
            [QUERY_KEYS.auth.email_otp_status, email],
            () => data,
          );
          return { success: true, data };
        }
        if (status === 401) {
          options?.onTokenExpired && options.onTokenExpired();
        }
        return { error: data?.errors?.[0] };
      }),
  });
};
